import type { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { STANDARD_MOVEMENT_TIME } from "./movementEffect";
import { MovementEffect } from "./movementEffect";

export class MeleeHitMovementEffect extends MovementEffect {
	static key = "MeleeHitMovementEffect";
	constructor(thing: PhysicalThing, origin: XY, destination: XY, time: number = STANDARD_MOVEMENT_TIME) {
		super(thing, origin, destination, time);
	}
}
